import axios from 'axios';

const BACKEND_URL = 'https://expense.server-issue.online';

const API = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  timeout: 15000 // Prevents requests from hanging indefinitely on slow mobile networks
});

API.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  
  // ✅ FIX: Strict validation ensures literal string "null"/"undefined" are never sent
  if (token && token !== 'null' && token !== 'undefined' && token.trim() !== '') {
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

API.interceptors.response.use(
  r => r, 
  err => {
    // Check if the failure happened on a public auth route
    const isAuthRoute = err.config?.url?.includes('/auth/');

    // ✅ FIX: Only redirect to login if the error happened on a PROTECTED route
    if (err.response?.status === 401 && !isAuthRoute) {
      localStorage.clear();
      if (window.navigation) {
        window.location.href = '/login';
      } else {
        window.location.reload();
      }
    }
    return Promise.reject(err);
  }
);

// --- AUTHENTICATION ENDPOINTS ---
export const loginUser      = (d) => API.post('/auth/login', d);
export const registerUser   = (d) => API.post('/auth/register', d);
export const forgotPassword = (d) => API.post('/auth/forgot-password', d);
export const resetPassword  = (d) => API.post('/auth/reset-password', d);

// --- APP CORE ENDPOINTS ---
export const getCategories     = ()            => API.get('/categories');
export const createCategory    = (data)        => API.post('/categories', data);
export const getDashboard      = ()            => API.get('/dashboard');
export const getExpenses       = (params)      => API.get('/expenses', { params });
export const getExpenseById    = (id)          => API.get(`/expenses/${id}`);
export const createExpense     = (data)        => API.post('/expenses', data);
export const updateExpense     = (id, data)    => API.put(`/expenses/${id}`, data);
export const deleteExpense     = (id)          => API.delete(`/expenses/${id}`);
export const getMonthlySummary = (year, month) => API.get(`/summary/${year}/${month}`);
export const setBudget         = (data)        => API.post('/budget', data);

// Dynamic profile update route
export const updateBudgetSettings = (data)    => API.put('/auth/update-budget', data);

export default API;
